import { useState } from "react";
import { toast } from "sonner";
import API from "../../lib/api";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { err, Field } from "./mpUtils";

/** Tenant flags a listing for the Fixlr team. */
export function ReportListingDialog({ contractor, reasons, open, onClose, onReported }) {
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await API.post(`/marketplace/contractors/${contractor.id}/report`, { reason, details });
      toast.success(data.message);
      onReported(data.report);
      onClose();
    } catch (e) { err(e, "Couldn't send the report"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="report-listing-dialog">
        <DialogHeader>
          <DialogTitle>Report {contractor.company_name}</DialogTitle>
          <DialogDescription>Goes straight to the Fixlr team, not the contractor. Listings reported by three customers are hidden automatically while we review.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Field label="What's the problem?">
            <select value={reason} onChange={(e) => setReason(e.target.value)} className="w-full h-9 rounded-md border border-input bg-background px-2 text-sm" data-testid="report-reason-select">
              <option value="">Choose a reason…</option>
              {Object.entries(reasons || {}).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </Field>
          <Field label="Tell us what happened"><Textarea rows={4} value={details} onChange={(e) => setDetails(e.target.value)} placeholder="Dates, job reference, what was agreed and what went wrong…" data-testid="report-details-input" /></Field>
          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={onClose} data-testid="report-cancel-btn">Cancel</Button>
            <Button variant="destructive" onClick={submit} disabled={busy || !reason || details.trim().length < 10} data-testid="report-submit-btn">{busy ? "Sending…" : "Send report"}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
